import { createGqlQuery } from '@/lib/query-helper'

import { graphql } from '@/gql'

const profileAccount = createGqlQuery({
  key: 'profile',
  query: graphql(`
    query GetProfile {
      getProfile {
        is_need_update_profile
        profile {
          id
          name
          email
          role
          phone
          confirmation
        }
      }
    }
  `),
})

export { profileAccount }
